<div class="eui-dashboard-button__content" [routerLink]="[url]">
    <div *ngIf="iconClass" class="eui-dashboard-button__content-main-icon">
        <span class="eui-dashboard-button__icon-element {{iconClass}}"></span>
    </div>
    <div *ngIf="!iconClass" class="eui-dashboard-button__content-main-label">
        {{mainLabel}}
    </div>
    <div class="eui-dashboard-button__content-title">
        {{label}}
    </div>
    <div class="eui-dashboard-button__content-sub-title">
        {{subLabel}}
    </div>
</div>
